import React from 'react';

// New UAE Dirham (AED) symbol — a "D" bowl crossed by two horizontal strokes.
// Stroke-based to match the lucide-react icon set used across the app.
export const DirhamIcon = ({ className = '', strokeWidth = 2, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M9 4h2.5a7 7 0 0 1 0 16H9z" />
    <path d="M4.5 10H17" />
    <path d="M4.5 14H17" />
  </svg>
);

export default DirhamIcon;
